import PaymentsTable from "./paymentsTable";

function init() {
  $('.returnOverpayment').on('click', function () {
    const element = $(this);
    $.get(element.data('action-url'), function () {
      element.parent().html(element.data('success'));
      element.hide();
      PaymentsTable.markTableObsolete();
    });
  });
}

$(function () {
  init();
});
